import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ChatBotNotificationService } from '../../shared/chat-bot-notification.service';
import { ChatBotStateService } from '../../shared/chat-bot-state.service';
import { GTMService } from '../../shared/gtm.service';
import { OneSignalService } from '../../shared/one-signal.service';
import { AnalyticsOutcomeEvents } from '../../shared/types/analytics-outcome.types';
import { ChatBotTrackEvents } from '../../shared/types/chat-bot-track-events.enum';
import { ChatBotTypes } from '../../shared/types/chat-bot-types.enum';

@Component({
  selector: 'lp2-chat-bot-section',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <lp2-balloon-popup *ngIf="(chatBotState$ | async).showWelcomeMessage" [offsetY]="12">
      {{ 'chatbot.welcomeMessage' | translate }}
    </lp2-balloon-popup>
    <lp2-chat-bot-fab
      *ngIf="(chatBotState$ | async).showFab"
      balloon-origin
      [badgeCount]="(unreadNotifications$ | async).length"
      (click)="openChatBotModal()"
    >
    </lp2-chat-bot-fab>
    <lp2-chat-bot-modal *ngIf="!(chatBotState$ | async).showLcFeedbackModal"
      [isOpen]="(chatBotState$ | async).showModal"
      (close)="closeChatBotModal()"
      (onboardingComplete)="onOnboardingComplete()"
    ></lp2-chat-bot-modal>
    <lp2-chat-bot-modal *ngIf="(chatBotState$ | async).showLcFeedbackModal"
      [isOpen]="(chatBotState$ | async).showLcFeedbackModal"
      [chatType]="chatBotTypes.LC_FEEDBACK"
      (close)="closeChatBotLcFeedbackModal()"
    ></lp2-chat-bot-modal>
  `,
})
export class ChatBotSectionComponent {
  public unreadNotifications$ = this.chatBotNotificationService.unreadNotifications$;

  public chatBotState$ = this.chatBotStateService.state$;
  public chatBotTypes = ChatBotTypes;

  constructor(
    private gtmService: GTMService,
    private readonly chatBotNotificationService: ChatBotNotificationService,
    private readonly chatBotStateService: ChatBotStateService,
    private readonly oneSignalService: OneSignalService
  ) {}

  public openChatBotModal() {
    this.gtmService.sendGA4Event(ChatBotTrackEvents.COPILOT_BUBBLE_TAP);
    this.oneSignalService.trackOutcome(AnalyticsOutcomeEvents.JENNY_BUBBLE_OPENED);
    this.chatBotStateService.openChatBotModal();
  }

  public closeChatBotModal() {
    this.chatBotStateService.closeChatBotModal();
  }

  public closeChatBotLcFeedbackModal() {
    this.chatBotStateService.closeChatBotLcFeedbackModal();
  }

  public onOnboardingComplete() {
    this.chatBotNotificationService.markAsRead$(1).subscribe();
    this.chatBotStateService.hideShowWelcomeMessage();
  }
}



// WEBPACK FOOTER //
// ./ts/app/home/chat-bot-section/chat-bot-section.component.ts